import { render, staticRenderFns } from "./SupportedCountryCode.vue?vue&type=template&id=12884fc2&scoped=true&"
import script from "./SupportedCountryCode.vue?vue&type=script&lang=js&"
export * from "./SupportedCountryCode.vue?vue&type=script&lang=js&"
import style0 from "./SupportedCountryCode.vue?vue&type=style&index=0&id=12884fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12884fc2",
  null
  
)

export default component.exports